<div class="form-control border border-solid rounded border-gray-300 dark:border-gray-500 p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center w-full" >
  <div *ngIf="aplicarTarifasPorCarril==false">
    <form class="row">
      <div class="dark:text-gray-100 dark:bg-transparent align-middle flex" style="width: 100%;">
        <span class="w-1/3 text-right ml-auto inline-block align-middle pt-5 mr-3 ">Nombre de tarifa</span>
        <input type="text"
          class="w-1/3 flex text-left estilo-dark dark:text-gray-100 dark:bg-gray-700 ml-auto tarifaNombre"
          (change)="getNombreTarifa($event);">
      </div>
      <div class="dark:text-gray-100 dark:bg-transparent align-middle flex" style="width: 25%;"
        *ngFor="let tarifa of dataTarifas">
        <span class="w-2/3 text-right ml-auto inline-block align-middle pt-5 mr-3">{{tarifa.vehiculo.tipo}}</span>
        <input type="number"
          class="w-1/3 flex text-left estilo-dark dark:text-gray-100 dark:bg-gray-700 ml-auto tarifasEntries"
          (change)="incrementarTarifas(tarifa,$event);" min="0" value="0" step="1">
      </div>
      <hr>
    </form>
    <div class="items-end flex" *ngIf="validator">
      <button
        class="flex estilo-dark dark:bg-transparent  dark:text-white dark:hover:border-blue-600 hover:border-blue-600"
        (click)="saveTarifas()">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
          stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
        </svg>
        <span class="ml-2">
          Guardar
        </span>
      </button>
    </div>
  </div>

  <app-tarifa-por-carril [dataTarifas]="dataTarifas" *ngIf="aplicarTarifasPorCarril==true"
    class="form-control flex justify-between p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center"></app-tarifa-por-carril>
  <ng-template #cargandoData> Cargando Información</ng-template>
  <br>
  <div *ngIf="dataCatTarifas != null;else cargandoData">
    <ngx-datatable class="material bord " [limit]="10" [rows]="rowsT" rowHeight="auto" [reorderable]="reorderable"
      [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">

      <!-- Nombre -->
      <ngx-datatable-column name="NOMBRE" [width]="20" class="bord">
        <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
          <p>{{ row.nombre }}</p>
        </ng-template>
      </ngx-datatable-column>
      <!-- Apellido Paterno -->
      <ngx-datatable-column name="Fecha creacion" prop="fechaCreacion" [width]="20">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          {{ value | date: 'dd/MM/yyyy' }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="Estatus" prop="activo" [width]="20">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>

          <svg style="height: 30px;" *ngIf="value == 1;else elsesvg" viewBox="0 0 10 10" fill="green"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="5" cy="5" r="2" />
          </svg>
          <ng-template #elsesvg>
            <svg style="height: 30px;" viewBox="0 0 10 10" fill="tomato" xmlns="http://www.w3.org/2000/svg">
              <circle cx="5" cy="5" r="2" />
            </svg>
          </ng-template>
        </ng-template>
      </ngx-datatable-column>
      <!-- Editar -->
      <ngx-datatable-column name="Acciones" prop="id">
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
          <div class="mt-5 flex lg:ml-4 lg:mt-0">
            <span class="hidden sm:block">
              <button (click)="openModalConfirm(row)" type="button"
                class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                <svg class="-ml-0.5 mr-1.5 h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"
                  aria-hidden="true">
                  <path
                    d="M2.695 14.763l-1.262 3.154a.5.5 0 00.65.65l3.155-1.262a4 4 0 001.343-.885L17.5 5.5a2.121 2.121 0 00-3-3L3.58 13.42a4 4 0 00-.885 1.343z" />
                </svg>
                Cambiar estatus
              </button>
            </span>

          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div *ngIf="confirmModal" class="modal-component-container fixed inset-0 overflow-y-auto">
    <div
      class="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>

      <div class="modal-space-container sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

      <div
        class="modal-container inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">
        <div class="modal-wrapper bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">

          <div class="modal-wrapper-flex sm:flex sm:items-start">

            <div class="modal-content mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">

              <div class="py-2 text-center">
                <span>¿Estás seguro activar la tarifa?, se actualizara automaticamente</span>
              </div>

              <table style="width: 75%;" *ngIf="isTarifasPorCarril==false">
                <thead>
                  <tr>
                    <th>Clasificacion</th>
                    <th>Monto</th>
                  </tr>
                </thead>
                <tbody class="tarifasFilas">
                  <tr *ngFor="let tarifa of jsonChangTarifa">
                    <td>{{tarifa.clasificacion }}</td>
                    <td>$ {{tarifa.monto}}</td>
                  </tr>
                </tbody>
              </table>

              <div class="w-full grid grid-cols-2 gap-4" *ngIf="isTarifasPorCarril==true">
                <div class="" *ngFor="let tarifaCarril of jsonTarifasPorCarril">
                  <label>Carril(es): {{ obtenerNombresCarriles(tarifaCarril.carriles) }}</label>

                  <table class="w-full">
                    <thead>
                      <tr>
                        <th>Clasificacion</th>
                        <th>Monto</th>
                      </tr>
                    </thead>
                    <tbody class="tarifasFilas">
                      <tr *ngFor="let tarifa of dataTarifas">
                        <td>{{tarifa.vehiculo.tipo }}</td>
                        <td>$ {{tarifaCarril.tarifas[tarifa.vehiculo.id]}}</td>
                      </tr>
                    </tbody>
                  </table>
                  <hr>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 flex flex-col">
          <div class="flex justify-end">
            <button (click)="confirmModal = false"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cerrar
            </button>
            <button (click)="changeStatusTarifa($event)"
              class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3 bg-white font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Aceptar
            </button>
          </div>

        </div>

      </div>
    </div>
  </div>
</div>


